import { apiClient } from './apiClient';

export type ProviderResumeResponse = {
  resumeUrl: string | null;
};

const API_V1 = '/api/v1';

export const resumesService = {
  getProviderResume(accountId: string, args?: { signal?: AbortSignal }) {
    return apiClient.getJson<ProviderResumeResponse>(`${API_V1}/resumes/providers/${accountId}`, {
      signal: args?.signal,
    });
  },
};
